<template>
  <div v-if="visible" class="load-more-wrapper">
    <button v-if="hasMore"
            :disabled="loading"
            class="load-more-btn"
            @click.prevent="$emit('load-more')">
      <span v-if="loading" class="loading-dots">
        <span></span>
        <span></span>
        <span></span>
      </span>
      <template v-else>
        <i class="uil-angle-down load-more-icon"></i>
        <span class="load-more-text">{{ $t('general.more') }}</span>
      </template>
    </button>
  </div>
</template>

<script>
export default {
  name: "LoadMoreButton",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    hasMore: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.load-more-wrapper {
  display: flex;
  justify-content: center;
  padding: 24px 16px;
}

.load-more-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 48px;
  min-width: 48px;
  padding: 12px 32px;
  border: 1px solid #d1d5db;
  border-radius: 12px;
  background-color: #fff;
  color: var(--primaryColor, var(--iconColor, #3e416d));
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.load-more-btn:hover {
  background-color: #f9fafb;
  border-color: var(--primaryColor, var(--iconColor, #3e416d));
}

.load-more-btn:active {
  background-color: #f3f4f6;
  transform: scale(0.98);
}

.load-more-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

.load-more-icon {
  font-size: 20px;
  line-height: 1;
}

.load-more-text {
  line-height: 1.4;
}

/* Loading Dots */
.loading-dots {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 20px;
}

.loading-dots span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: var(--primaryColor, var(--iconColor, #3e416d));
  display: inline-block;
  animation: loading-dots 1.4s infinite ease-in-out both;
}

.loading-dots span:nth-child(1) {
  animation-delay: -0.32s;
}

.loading-dots span:nth-child(2) {
  animation-delay: -0.16s;
}

.loading-dots span:nth-child(3) {
  animation-delay: 0s;
}

@keyframes loading-dots {
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1.2);
    opacity: 1;
  }
}

@media (max-width: 767px) {
  .load-more-wrapper {
    padding: 20px 16px;
  }

  .load-more-btn {
    width: 100%;
    padding: 14px 24px;
    border-radius: 12px;
    font-size: 15px;
  }

  .load-more-btn:hover {
    background-color: #fff;
    border-color: #d1d5db;
  }
}
</style>
